import React from 'react';
import { getSegmentArray } from '../utils/getSegmentArray';
import { useLengthContext, useSelectionContext } from './Context';
export { Context } from './Context';
export const Root = (props) => <div {...props} data-code-input="root"/>;
export const Absolute = (props) => (<div {...props} data-code-input="absolute" style={{
        bottom: 0,
        display: 'flex',
        justifyContent: 'space-between',
        left: 0,
        position: 'absolute',
        right: 0,
        top: 0,
        ...props.style,
    }}/>);
const handleScroll = (event) => {
    event.preventDefault();
    event.stopPropagation();
    event.currentTarget.scrollTop = 0;
    event.currentTarget.scrollLeft = 0;
};
export const InputScrollWrapper = (props) => (<div {...props} data-code-input="input-scroll-wrapper" onScroll={handleScroll} style={{
        ...props.style,
        height: '100%',
        overflow: 'hidden',
    }}/>);
export const Input = React.forwardRef((props, ref) => {
    const length = useLengthContext();
    return (<input {...props} ref={ref} data-code-input="input" maxLength={length} minLength={length} style={{
            ...props.style,
            appearance: 'none',
            background: 'transparent',
            border: '0 solid transparent',
            display: 'block',
            font: 'inherit',
            letterSpacing: 'inherit',
            margin: '0',
            outline: 'none',
            padding: '0',
            textIndent: 'inherit',
            width: props.width ?? '200%',
        }} width={undefined}/>);
});
export const SegmentRenderer = (props) => {
    const selection = useSelectionContext();
    const length = useLengthContext();
    const _selection = selection;
    const segmentArray = getSegmentArray(length, _selection);
    const content = segmentArray.map(({ position, state }, index) => props.children({ index, position, selection: _selection, state }));
    return <>{content}</>;
};
